export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5142.de9edf03.jpg";